// extracted by mini-css-extract-plugin
module.exports = {"online":"styles_online__2eE_A","offline":"styles_offline__29cAS","maintenance":"styles_maintenance__3XGlF"};